import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/territories/$territoryId/users')({
  beforeLoad: ({ context, params }): void => {
    // Back to the territory's General tab, as sibling tabs do. SWOOP-430: General then sends a Billing Officer
    // (who holds no users:list) on to the Billing tab, instead of the Territories list.
    if (context.permissions.isReady && !context.permissions.hasPermission('users:list')) {
      throw redirect({ params: { territoryId: params.territoryId }, to: '/settings/territories/$territoryId' });
    }
  },
  component: lazyRouteComponent(() =>
    import('&/features/settings/users/pages/users-page').then((m) => ({ default: m.default })),
  ),
  staticData: { titleKey: 'users' },
});
